"use strict";

import config from '../configLoader';

export default class LoanInformation {

	constructor(linkId) 
	{
		this.uri = config("services.sparxpres.uri");
		this.endpoint = config("services.sparxpres.endpoints.loanInfo");
		this.linkId = linkId;
	}

	/**
     * Get loan details from loan calculator
     * @param {Number} amountCents
	 * @param {Number} duration
     * @return {Object} promise
     */
	getLoanInformation(amountCents = 0, duration = 0)
	{
		let self = this;

		const urlParameters = new URLSearchParams({
			"linkId": self.linkId,
			"amount": Math.ceil(amountCents / 100),
			"websaleversion": "XpresWebSale_v1.1.01-dev"
		});
		if (duration > 0) urlParameters.append("period", duration);

		const url = self.uri + self.endpoint + "?" + urlParameters.toString();

		return fetch(url, {
			method: 'GET'
		})
			.then(response => {
				if (response.status !== 200) {
					throw new Error("HTTP status " + response.status);
				}
				return response.json();
			})
			.then(data => data);
	}
	
}